// @ts-nocheck
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useI18n } from '../context/I18nContext';
import notify from '../utils/toast';
import AppModal from '../components/AppModal';

export default function Users() {
    const { t, td } = useI18n();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const closeUserModal = () => {
        setShowModal(false);
        setForm({ name: '', email: '', phone: '', password: '', role: 'sales' });
    };
    const [form, setForm] = useState({ name: '', email: '', phone: '', password: '', role: 'sales' });

    const load = () => {
        setLoading(true);
        api.get('/auth/users').then((r) => setUsers(r.data.data)).finally(() => setLoading(false));
    };

    useEffect(() => { load(); }, []);

    const handleCreate = async (e) => {
        e.preventDefault();
        try {
            await api.post('/auth/register', form);
            closeUserModal();
            load();
        } catch (err) {
            notify.apiError(err);
        }
    };

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h4 className="mb-1">Users</h4>
                    <p className="text-muted mb-0">Staff & customers</p>
                </div>
                <button className="btn btn-primary" onClick={() => setShowModal(true)}>
                    <i className="bi bi-person-plus me-1"></i> Add User
                </button>
            </div>

            <div className="card table-card">
                <div className="table-responsive">
                    <table className="table table-hover mb-0">
                        <thead className="table-light">
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Role</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan={5} className="text-center py-4"><div className="spinner-border spinner-border-sm text-success" /></td></tr>
                            ) : users.map((u) => (
                                <tr key={u.id}>
                                    <td className="fw-semibold">{u.name}</td>
                                    <td>{u.email}</td>
                                    <td>{u.phone || '—'}</td>
                                    <td><span className="badge bg-secondary text-uppercase">{td('role', u.role)}</span></td>
                                    <td>{u.is_active ? <span className="text-success">Active</span> : <span className="text-danger">Inactive</span>}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {showModal && (
                <div className="modal show d-block app-modal" style={{ background: 'rgba(0,0,0,0.5)' }} onClick={closeUserModal}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <form className="modal-content" onSubmit={handleCreate}>
                            <div className="modal-header">
                                <h5 className="modal-title">Add User</h5>
                                <button type="button" className="btn-close" onClick={closeUserModal} />
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">Name *</label>
                                    <input className="form-control" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Email *</label>
                                    <input type="email" className="form-control" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Phone</label>
                                    <input className="form-control" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Password *</label>
                                    <input type="password" className="form-control" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Role *</label>
                                    <select className="form-select" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
                                        <option value="admin">Admin</option>
                                        <option value="sales">Sales</option>
                                        <option value="finance">Finance</option>
                                        <option value="customer">Customer</option>
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeUserModal}>Cancel</button>
                                <button type="submit" className="btn btn-primary">Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
}
